module.exports = __webpack_public_path__ + "static/img/医疗卡片2_初始状态@2x.922f04bc.png";